import { defineComponent as _defineComponent } from 'vue'
import type { HomeModules } from '@/features/onboarded-home/types';

import SponsoredRecommendation from '@/components/sponsored-recommendations/SponsoredRecommendation.vue';

import BecauseYouLikedModule from '@/features/onboarded-home/components/modules/BecauseYouLikedModule.vue';
import ClassicModule from '@/features/onboarded-home/components/modules/ClassicModule.vue';
import EditorsPickModule from '@/features/onboarded-home/components/modules/EditorsPickModule.vue';
import NewOnYourServicesModule from '@/features/onboarded-home/components/modules/new-on-your-services/NewOnYourServicesModule.vue';
import SponsoredRecommendationModule from '@/features/onboarded-home/components/modules/SponsoredRecommendationModule.vue';
import SportsModule from '@/features/onboarded-home/components/modules/sports/SportsModule.vue';
import SpotlightModulesLoader from '@/features/onboarded-home/components/modules/SpotlightModulesLoader.vue';
import StreamingChartModule from '@/features/onboarded-home/components/modules/streaming-chart/StreamingChartModule.vue';
import TextRecommendationModule from '@/features/onboarded-home/components/modules/TextRecommendationModule.vue';

import { SraPlacement } from '@/@types/graphql-types';

import { useUserStore } from '@/helpers/composables/useStores';
import { useModuleContextData } from '@/features/onboarded-home/tracking';
import { useSendBidId } from '@/components/sponsored-recommendations/useSendBidId';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModulesLoader',
  props: {
    modules: null
  },
  setup(__props: any) {

const props = __props as { modules: HomeModules };



const { displayHomeSportsModule } = useUserStore();
const { provideGlobalModuleSize } = useModuleContextData();

const { sponsoredAd, hasActiveSRCampaign, isShadowCampaign } = useSendBidId({
	pageType: 'VIEW_HOME_USER',
	placement: SraPlacement.Home,
});

/** Wrapper module for Sponsored Recommendations */
const SR_MODULE_CONTAINER = 'HMWatchedBySimilarUsers' as const;

const moduleComponents = computed(() => {
	const modulesToLoad = [...props.modules.filter(m => m != null)];

	// FE Hack to sort SR module first
	if (hasActiveSRCampaign.value) {
		const mIndex = modulesToLoad.findIndex(m => m.__typename === SR_MODULE_CONTAINER);
		if (mIndex > 0) modulesToLoad.unshift(modulesToLoad.splice(mIndex, 1)[0]);
	}

	return modulesToLoad
		.map(moduleData => {
			if (moduleData == null) return null;

			switch (moduleData.__typename) {
				case SR_MODULE_CONTAINER:
				case 'HMWatchedBySimilarUsers': {
					if (hasActiveSRCampaign.value) {
						return { moduleData, component: SponsoredRecommendationModule };
					}

					return { moduleData, component: ClassicModule };
				}

				case 'HMSpotlight': {
					if (moduleData.modules.length) {
						return { moduleData, component: SpotlightModulesLoader };
					}

					return null;
				}

				case 'HMHighlightArticle':
				case 'HMTopHighlightArticle':
					return { moduleData, component: EditorsPickModule };

				case 'HMTextRecommendation':
					return { moduleData, component: TextRecommendationModule };

				case 'HMTop3PerPackageToday':
					return { moduleData, component: StreamingChartModule };

				case 'HMNewPerPackageToday':
					return { moduleData, component: NewOnYourServicesModule };

				case 'HMSportsLiveFootball':
				case 'HMSportsUpcomingFootball': {
					if (displayHomeSportsModule.value && moduleData.events.length > 0) {
						return { moduleData, component: SportsModule };
					}

					return null;
				}

				case 'HMBecauseYouLikedTitle':
					return { moduleData, component: BecauseYouLikedModule };

				case 'HMTopGenre':
				case 'HMPermanentAudience':
				case 'HMTVOD':
					return { moduleData, component: ClassicModule };
				// case 'HMAVOD':

				case 'HMTop10InYourCountry':
					return {
						moduleData,
						component: ClassicModule,
						props: { showPosition: true, verticalLayoutOnMobile: true },
					};

				default:
					return null;
			}
		})
		.filter(m => m != null);
});

provideGlobalModuleSize(() => moduleComponents.value.length);

return { __sfc: true,props, displayHomeSportsModule, provideGlobalModuleSize, sponsoredAd, hasActiveSRCampaign, isShadowCampaign, SR_MODULE_CONTAINER, moduleComponents, SponsoredRecommendation }
}

})